const mixins = {
  computed: {
    isLoginPageActive() {
      return this.$route.name === 'Init';
    },
  },

  methods: {
    getEnvironmentLayoutName() {
      const LAYOUT_BY_ENV = {
        volkswagen: 'VolkswagenLayout',
        audi: 'AudiLayout',
        seat: 'SeatLayout',
        cupra: 'CupraLayout',
      };

      return LAYOUT_BY_ENV[process.env.VUE_APP_BRAND];
    },

    formatMoney(amount) {
      if (!amount) return '0';

      return new Intl.NumberFormat('es-MX', { style: 'decimal', minimumFractionDigits: 2 }).format(amount);
    },

    checkTermsAccepted() {
      const privacy = this.$session.get('privacy');
      const transferData = this.$session.get('transferData');
      const isPrivacyShow = !(privacy && transferData);

      const isInternal = Boolean(Number(localStorage.getItem('isInternal')));
      const isNotInternal = !isInternal;

      return isPrivacyShow && isNotInternal;
    },
    logOutLogic() {
      // Si es producción y ademas no es usuario interno - invocamos el logout de IDKIT
      const superorder = this.$session.get('superOrderId');
      // Limpiamos la sesión
      this.$session.clear();
      this.$session.set('superOrderId', superorder);
      // Removemos isInternal de la sesion
      localStorage.removeItem('isInternal');
      this.$router.push('/login');
    },
  },
};

export default mixins;
